const SOCIAL_REGISTRATION_STORAGE_KEY = "wifiads.socialRegistration.pending";

export function persistPendingSocialRegistration(payload) {
  if (!payload) {
    return;
  }

  sessionStorage.setItem(
    SOCIAL_REGISTRATION_STORAGE_KEY,
    JSON.stringify({
      ...payload,
      storedAt: Date.now(),
    })
  );
}

export function loadPendingSocialRegistration() {
  try {
    const rawValue = sessionStorage.getItem(SOCIAL_REGISTRATION_STORAGE_KEY);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch (error) {
    return null;
  }
}

export function clearPendingSocialRegistration() {
  sessionStorage.removeItem(SOCIAL_REGISTRATION_STORAGE_KEY);
}
